import { render, staticRenderFns } from "./list.vue?vue&type=template&id=bc811c2e"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=bc811c2e&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc811c2e')) {
      api.createRecord('bc811c2e', component.options)
    } else {
      api.reload('bc811c2e', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=bc811c2e", function () {
      api.rerender('bc811c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/statisticsManagement/statisticsReport/list.vue"
export default component.exports